import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { fetchNewspapers } from "../services/newspaperService";
import HeroSection from "../components/HeroSection";

function ReadMore() {
  const { date } = useParams();
  const [papers, setPapers] = useState([]);
  const [selectedDate, setSelectedDate] = useState(date);
  const pdfRef = useRef(null);

  useEffect(() => {
    fetchNewspapers().then(setPapers);
  }, []);

  const currentPaper = papers.find(p => p.id === selectedDate);

  const printPDF = () => {
    if (pdfRef.current) {
      pdfRef.current.contentWindow.print();
    }
  };

  if (!currentPaper) return <p>Loading...</p>;

  return (
    <div className="py-3">
      <HeroSection pageType="other" />
      <h2 className="mt-3">{currentPaper.title}</h2>

      {/* Date Dropdown */}
      <select
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)} 
        className="form-select w-25"
      >
        {papers.map(p => (
          <option key={p.id} value={p.id}>
            {p.date}
          </option>
        ))}
      </select>

      <br /><br />

      {/* Buttons */}
      {/* <button onClick={printPDF}>Print Newspaper</button> */}

      <a href={currentPaper.pdf_url} target="_blank" rel="noreferrer">
        <button style={{ marginLeft: "10px" }} className="btn btn-primary">Open PDF</button>
      </a>

      <br /><br />

      {/* PDF Viewer */}
      <iframe
        ref={pdfRef}
        src={currentPaper.pdf_url}
        title="Newspaper PDF"
        width="100%"
        height="600px"
        style={{ border: "1px solid #ccc" }}
      />
    </div>
  );
}

export default ReadMore;
